import {
  type ShipmentDeliveryStatusType,
  SHIPMENT_DELIVERY_STATUS_TYPE
} from '@/libs/api/types'

/**
 * 配送進捗の昇順（手前ほど未確定）。
 * CANCELLED は軸跨ぎ（§4.3 で「対応なし」）のため進捗順から除外する。
 */
const PROGRESS_ORDER: ShipmentDeliveryStatusType[] = [
  SHIPMENT_DELIVERY_STATUS_TYPE.UNORDERED,
  SHIPMENT_DELIVERY_STATUS_TYPE.BEFORE_DISPATCH,
  SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCHING,
  SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCH_CONFIRMED,
  SHIPMENT_DELIVERY_STATUS_TYPE.TRUCK_NOTIFIED,
  SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_INSTRUCTED,
  SHIPMENT_DELIVERY_STATUS_TYPE.SAME_DAY_GUIDED,
  SHIPMENT_DELIVERY_STATUS_TYPE.LOADING_COMPLETED,
  SHIPMENT_DELIVERY_STATUS_TYPE.UNLOADING_COMPLETED,
  SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_COMPLETED
]

/**
 * 1 本の配車バー（矢羽根本体）に乗る複数の配送依頼の deliveryStatus を、
 * 1 つの代表ステータスに集約する。
 *
 * - 最も進捗が手前（未確定寄り）の依頼を代表として返す。配車板上で deliveryStatus は
 *   自由に変更できるため、未受注 (UNORDERED) / 受注済 (BEFORE_DISPATCH) もそのまま
 *   代表表示する（旧 案 B-2 の「確定前は一律 DISPATCHING に丸める」挙動は廃止）。
 * - CANCELLED / REVOKED は軸跨ぎのため集約対象から除外する。残りが無ければ
 *   （全件が軸跨ぎなら）先頭の軸跨ぎ値を、依頼が 0 件なら null を返す。
 *
 * VOC_PJ-981 #4620: REVOKED（取消）を除外対象に追加した。取消は未配車のときのみ
 * 設定できるため矢羽根に乗る経路は無い想定だが、PROGRESS_ORDER は型で網羅が
 * 強制されない配列であり、未登録値は indexOf が -1 を返して「最も進捗が手前」と
 * 誤判定される。サイレント誤動作を防ぐため明示的に除外する。
 */
const CROSS_AXIS_STATUSES: ShipmentDeliveryStatusType[] = [
  SHIPMENT_DELIVERY_STATUS_TYPE.CANCELLED,
  SHIPMENT_DELIVERY_STATUS_TYPE.REVOKED
]

export function aggregateDeliveryStatus(
  statuses: ShipmentDeliveryStatusType[]
): ShipmentDeliveryStatusType | null {
  const target = statuses.filter((s) => !CROSS_AXIS_STATUSES.includes(s))

  if (target.length === 0) {
    // 全件が軸跨ぎ（キャンセル / 取消）の場合は先頭の値をそのまま代表とする
    return statuses.length > 0 ? statuses[0] : null
  }

  return target.reduce((slowest, s) =>
    PROGRESS_ORDER.indexOf(s) < PROGRESS_ORDER.indexOf(slowest) ? s : slowest
  )
}
